import { Box, BoxProps } from '@mui/material';

const SLOGAN_SRC = '/marketing/slogan.svg';
const SLOGAN_ALT = 'Moderne Benefits. Flexible Mobilität.';

export default function MarketingSlogan({ sx, ...props }: BoxProps) {
  return (
    <Box
      component="img"
      src={SLOGAN_SRC}
      alt={SLOGAN_ALT}
      draggable={false}
      sx={[
        {
          display: 'block',
          height: 'auto',
          width: { xs: 280, sm: 360, md: '80%' },
          ml: { md: 10, lg: 20 },
          maxWidth: { md: 560 },
          py: { xs: 4, md: 6 },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    />
  );
}
